import clsx from 'clsx'
import { type PropsWithChildren } from 'react'
import { BreadcrumbLayout } from '../page-layout/breadcrumb'

interface PageHeaderProps extends PropsWithChildren {
  title: string
  breadcrumb?: boolean
  classNames?: {
    title?: string
  }
}

export function PageHeader({
  title,
  classNames,
  breadcrumb,
  children
}: PageHeaderProps) {
  return (
    <div className="px-13 pt-10">
      <h1
        className={clsx(
          {
            'text-base': !!breadcrumb
          },
          'text-2xl font-bold text-[var(--brand-blue-2)]',
          classNames?.title
        )}
      >
        {title}
      </h1>
      <div className="border-b border-muted-foreground/60"></div>
      <div className={clsx('w-full my-4')}>
        <div className="flex justify-between">
          {breadcrumb && <BreadcrumbLayout />}
          {children}
        </div>
      </div>
      {!!children && (
        <div className="border-b border-muted-foreground/60"></div>
      )}
    </div>
  )
}
